/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_donut_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The chart is generated locally in your browser and your data never leaves your device.`)
};

const es_donut_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El gráfico se genera localmente en tu navegador y tus datos nunca salen de tu dispositivo.`)
};

const de_donut_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Das Diagramm wird lokal in Ihrem Browser erstellt, und Ihre Daten verlassen Ihr Gerät nie.`)
};

const nl_donut_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. De grafiek wordt lokaal in je browser gegenereerd en je data verlaat nooit je apparaat.`)
};

const fr_donut_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Le graphique est généré localement dans votre navigateur et vos données ne quittent jamais votre appareil.`)
};

const it_donut_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Il grafico viene generato localmente nel tuo browser e i tuoi dati non lasciano mai il tuo dispositivo.`)
};

const pt_br2_donut_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O gráfico é gerado localmente no seu navegador e seus dados nunca saem do seu dispositivo.`)
};

const pt_donut_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O gráfico é gerado localmente no seu navegador e os seus dados nunca saem do seu dispositivo.`)
};

const ja_donut_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。グラフはブラウザ内でローカルに生成され、データが端末から外部に送信されることはありません。`)
};

const zh_donut_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的。图表在你的浏览器本地生成，你的数据不会离开你的设备。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const donut_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.donut_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("donut_faq_a4", locale)
	if (locale === "en") return en_donut_faq_a4(inputs)
	if (locale === "es") return es_donut_faq_a4(inputs)
	if (locale === "de") return de_donut_faq_a4(inputs)
	if (locale === "nl") return nl_donut_faq_a4(inputs)
	if (locale === "fr") return fr_donut_faq_a4(inputs)
	if (locale === "it") return it_donut_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_donut_faq_a4(inputs)
	if (locale === "pt") return pt_donut_faq_a4(inputs)
	if (locale === "ja") return ja_donut_faq_a4(inputs)
	return zh_donut_faq_a4(inputs)
};